(function() {
  var root = document.querySelector('.d3x-root') || document;

  /* MOBILE: tab switching */
  var tabs = root.querySelectorAll('.tab-btn');
  var sections = root.querySelectorAll('.faq-section');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = tab.getAttribute('data-section');
      tabs.forEach(function(t) { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
      sections.forEach(function(s) { s.classList.remove('active'); });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      var sec = root.querySelector('#section-' + target); /* FIX: use querySelector, not getElementById (Element has no getElementById) */
      if (sec) sec.classList.add('active');
    });
  });

  /* FAQ accordion */
  root.querySelectorAll('.faq-q').forEach(function(q) {
    q.addEventListener('click', function() {
      var item = q.parentElement;
      var isOpen = item.classList.contains('open');
      var isDesktop = window.innerWidth >= 768;
      if (isDesktop) {
        root.querySelectorAll('.faq-item.open').forEach(function(i) { if (i !== item) i.classList.remove('open'); });
      } else {
        var section = item.closest('.faq-section');
        if (section) section.querySelectorAll('.faq-item.open').forEach(function(i) { i.classList.remove('open'); });
      }
      if (!isOpen) item.classList.add('open');
    });
  });

  /* DESKTOP: sidebar click → scroll to section */
  var sidebarBtns = root.querySelectorAll('.sidebar-nav-btn');
  sidebarBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var el = document.getElementById(btn.getAttribute('data-target'));
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.pageYOffset - 40;
      window.scrollTo({ top: top, behavior: 'smooth' });
      sidebarBtns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* DESKTOP: scroll-spy */
  try {
    if ('IntersectionObserver' in window) {
      var spyIo = new IntersectionObserver(function(entries) {
        if (window.innerWidth < 768) return;
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            sidebarBtns.forEach(function(b) {
              b.classList.toggle('active', b.getAttribute('data-target') === id);
            });
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      root.querySelectorAll('.faq-section').forEach(function(s) { spyIo.observe(s); });
    }
  } catch(e) {}

  /* Scroll reveal — FIX: add js-reveal to .d3x-root to match CSS selector .d3x-root.js-reveal .reveal */
  try {
    if ('IntersectionObserver' in window) {
      root.classList.add('js-reveal');
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.1 });
      root.querySelectorAll('.reveal').forEach(function(el) { io.observe(el); });
      setTimeout(function() {
        root.querySelectorAll('.reveal:not(.in)').forEach(function(el) { el.classList.add('in'); });
      }, 2000);
    }
  } catch(e) {}

})();
